import { useCallback, useState } from "react";

import { AjaxResult } from "../../../../enums/ajaxResult";
import { useApi } from "../../../useApi";

export function useOrganizationLogoLoad(organizationId: number | undefined) {
    const [logo, setLogo] = useState<string>();
    const [loading, setLoading] = useState(false);
    const { orgApi } = useApi();

    const loadLogo = useCallback(() => {
        if (!organizationId) {
            return;
        }
        setLoading(true);
        setLogo(undefined);
        orgApi.getLogo(organizationId).then((r) => {
            if (r.result === AjaxResult.Success && r.data) {
                setLogo(URL.createObjectURL(r.data));
            }
            setLoading(false);
        });
    }, [orgApi, organizationId]);

    return {
        loadLogo,
        logo,
        loading,
    };
}